import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentLawEnforcementModel } from '../models/incident-law-enforcement.model';

@Injectable()
export class LawEnforcementIncidentService extends IncidentServiceBase<IncidentLawEnforcementModel> {
    constructor() {
        super('IncidentLawEnforcement', () => new IncidentLawEnforcementModel());
    }

    public getAllAgencies() {
        return this.get('Incident/LawEnforcement/Agencies');
    }

    public getContact(agencyId: number) {
        var toRet = this.get(`Incident/LawEnforcement/Agencies/Contact/${agencyId}`);
        return toRet;
    }

    public getLookups() {
        return this.get('Incident/LawEnforcement/lookups');
    }
}
